import { LayerIds, type MapboxStyleLayer } from "fond/types";

const crossingFilter = ["==", ["get", "user_Crossing"], "YES"];

export const inStreetStyles: MapboxStyleLayer[] = [
  {
    id: "prefer-path-line",
    type: "line",
    filter: ["all", ["<", ["get", "user_CostFactor"], 1], ["==", ["get", "user_layerId"], LayerIds.inStreet]],
    paint: {
      "line-color": "#00FF00",
      "line-width": ["case", crossingFilter, 2, 4],
    },
  },
  {
    id: "avoid-path-line",
    type: "line",
    filter: ["all", [">", ["get", "user_CostFactor"], 1], ["==", ["get", "user_layerId"], LayerIds.inStreet]],
    paint: {
      "line-color": "#FF0000",
      "line-width": ["case", crossingFilter, 2, 4],
    },
  },
  {
    id: "neutral-path-line",
    type: "line",
    filter: [
      "all",
      ["any", ["==", ["get", "user_CostFactor"], 1], ["==", ["get", "user_CostFactor"], null]],
      ["==", ["get", "user_layerId"], LayerIds.inStreet],
    ],
    paint: {
      "line-color": "#AAA",
      "line-width": ["case", crossingFilter, 2, 4],
    },
  },
  {
    id: "gl-draw-line-active",
    type: "line",
    filter: ["all", ["==", "$type", "LineString"], ["==", "active", "true"]],
    paint: {
      "line-color": "rgb(33, 150, 243)",
      "line-opacity": 0.5,
      "line-width": 10,
    },
  },
];
